import { createContext, useContext } from 'react';
import { useImmerReducer } from 'use-immer';

const chartInit = {
  cubeApi: null,
  isChartEditorOpen: false,
  isLoadingCharts: false,
  charts: {},
  accountChartsList: [], // a list of account-shared chartIds in a-z order of the chart's title
  marketplaceChartsList: [], // a list of published chartIds in a-z order of the chart's title
  draftChartsList: [], // a list of draft chartIds in a-z order of the chart's title
  chartNameFlag: { uniqueNameinSameAccount: true, msg: "" },
  isLoadingChart: false,
  selectedChart: null,
  isSavingChart: false,

  // chartEditVersions will eventually be an array of versions of the same chart as it gets edited so we can do undos and redos
  chartEditVersions: [],

  // templates
  templates: {},
  isLoadingTemplates: false,
};

function chartReducer ( draft, { type, payload } ) {
    switch (type) {
      case "setCubeApi": {
        draft.cubeApi = payload;
        break;
      }
      case "openChartEditor": {
        draft.isChartEditorOpen = true;
        break;
      }
      case "closeChartEditor": {
        draft.isChartEditorOpen = false;
        break;
      }
      case "setIsLoadingCharts": {
        draft.isLoadingCharts = payload;
        break;
      }
      case "setCharts": {
        payload.forEach((chart) => {
          draft.charts[chart.id] = chart;
        });
        break;
      }
      case "setChartNameFlag": {
        draft.chartNameFlag = payload;
        break;
      }
      case "setIsLoadingChart": {
        draft.isLoadingChart = payload;
        break;
      }
      case "setSelectedChart": {
        draft.selectedChart = payload;
        break;
      }
      case "setIsSavingChart": {
        draft.isSavingChart = payload;
        break;
      }
      case "addChartToList": {
        draft.charts[payload?.id] = payload;
        break;
      }
      case "addNewCharts": {
        payload.forEach(chart=>{
          draft.charts[chart.id] = chart;
        })
        break;
      }
      case "updateChartInList": {
        draft.charts[payload.id] = payload;
        break;
      }
      case "removeChart": {
        delete draft.charts[payload.Charts[0].chartId];
        break;

      }
      case "pushChartChange": {
        // adding changes to the beginning of the array so that the newest one can be accessed easily using arr[0]
        draft.chartEditVersions.unshift(payload);
        break;
      }
      case "setIsLoadingTemplates": {
        draft.isLoadingTemplates = payload;
        break;
      }
      case "setTemplates": {
        payload.forEach((chart) => {
          draft.templates[chart.id] = chart;
        });
        break;
      }
      case "addTemplate": {
        draft.templates[payload.id] = payload;
        break;
      }
      case "updateTemplate": {
        const i = draft.templates.findIndex((c) => c.id === payload.id);
        if (i >= 0) {
          draft.templates = [
            ...draft.templates.slice(0, i),
            payload,
            ...draft.templates.slice(i + 1),
          ];
        }
        break;
      }
      case "removeTemplate": {
        const i = draft.templates.findIndex((c) => c.id === payload.id);
        if (i >= 0) {
          draft.templates = [
            ...draft.templates.slice(0, i),
            ...draft.templates.slice(i + 1),
          ];
        }
        break;
      }
      default: {
        return null;
      }
    }
}

const [ChartContext,ChartDispatchContext] = [createContext(null),createContext(null)];

export default function ChartProvider ({ children, init }) {
    const [chartStore, dispatch] = useImmerReducer(chartReducer, init || chartInit);

    return (
        <ChartContext.Provider value={chartStore}>
            <ChartDispatchContext.Provider value={dispatch}>
                {children}
            </ChartDispatchContext.Provider>
        </ChartContext.Provider>
    )
}

export function useChartStore() {
    return useContext(ChartContext);
}

export function useChartDispatch() {
    return useContext(ChartDispatchContext);
}